import {FC} from 'react'
import {Card} from 'react-bootstrap'
import bgImage from '../../assets/img/bg.png'
import {truncateText} from 'thesis-and-dissertations/helpers/helper'

type Props = {
  data: any
  isMobile?: boolean
}

const Page2: FC<Props> = ({data, isMobile = false}) => {
  return (
    <Card className='h-100 border-0 bg-light bg-opacity-75 shadow-sm'>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          height: '100%',
        }}
        className={isMobile ? 'p-8' : 'p-14'}
      >
        <div className='d-flex justify-content-start'>
          <img
            src={require('../../assets/img/suitcase.png')}
            style={{width: isMobile ? '24px' : '30px', height: isMobile ? '24px' : '30px', marginRight: '10px'}}
            alt='suitcase'
          />
          <p className='mb-3' style={{fontSize: isMobile ? '18px' : '22px', fontWeight: '700'}}>
            Jejak Karier & Kontribusi
          </p>
        </div>

        {data?.pekerjaan_saat_ini && data?.perusahaan_instansi && (
          <>
            <div className='d-flex justify-content-start'>
              <img
                src={require('../../assets/img/star.png')}
                style={{width: isMobile ? '12px' : '15px', height: isMobile ? '12px' : '15px', marginRight: '5px'}}
                alt='star'
              />
              <p style={{fontSize: isMobile ? '13px' : '15px'}}> Posisi & Instansi</p>
            </div>

            <p style={{fontSize: isMobile ? '13px' : '15px'}}>
              {data?.pekerjaan_saat_ini} di {data?.perusahaan_instansi}
            </p>
          </>
        )}

        {data?.deskripsi_singkat_pekerjaan && (
          <>
            <div className='d-flex justify-content-start mt-4'>
              <img
                src={require('../../assets/img/star.png')}
                style={{width: isMobile ? '12px' : '15px', height: isMobile ? '12px' : '15px', marginRight: '5px'}}
                alt='star'
              />
              <p style={{fontSize: isMobile ? '13px' : '15px'}}> Perjalanan Karier</p>
            </div>
            <p style={{fontSize: isMobile ? '13px' : 'inherit'}}>{data?.deskripsi_singkat_pekerjaan}</p>
          </>
        )}

        {data?.prestasi_utama && (
          <>
            <div className='d-flex justify-content-start mt-5'>
              <img
                src={require('../../assets/img/star.png')}
                style={{width: isMobile ? '12px' : '15px', height: isMobile ? '12px' : '15px', marginRight: '5px'}}
                alt='star'
              />
              <p style={{fontSize: isMobile ? '13px' : '15px'}}> Prestasi Utama</p>
            </div>

            {data?.prestasi_utama
              ?.split(';')
              ?.map((item: any) => item.trim())
              ?.filter((item: any) => item)
              ?.map((item: any, index: any) => (
                <div
                  key={index}
                  className='mb-3 px-3 pt-3 rounded shadow-sm mt-2'
                  style={{background: '#F9FAFB'}}
                >
                  <p className='pb-3' style={{fontSize: isMobile ? '13px' : 'inherit'}}>
                    {truncateText(item, isMobile ? 200 : 300)}
                  </p>
                </div>
              ))}
          </>
        )}

        {data?.kontribusi_masyarakat && (
          <div className='mb-3 mt-5 px-3 bg-white rounded shadow-sm'>
            <p className='pt-3' style={{fontSize: isMobile ? '14px' : '16px', fontWeight: '600'}}>
              Kontribusi untuk Masyarakat
            </p>
            <p className='pb-3' style={{fontSize: isMobile ? '13px' : 'inherit'}}>
              {truncateText(data?.kontribusi_masyarakat, isMobile ? 180 : 260)}
            </p>

            <p className='pb-4' style={{fontSize: isMobile ? '12px' : 'inherit'}}>
              <i className='bi bi-award text-black'></i> Making Impact • Creating Change
            </p>
          </div>
        )}
      </div>
    </Card>
  )
}

export default Page2